const dres = [
  {
    id: 'ee5a1209-2b9d-4e01-b62a-65e085eab634',
    nome: 'RECEITA_VENDA',
    natureza: 'RECEITA',
    descricao: 'Receita de Vendas',
  },
  {
    id: 'a87d5baf-6cdd-413a-b9c3-84bc16f40cb8',
    nome: 'RECEITA_FRETE_ENTREGA',
    natureza: 'RECEITA',
    descricao: 'Receita de Fretes e Entregas',
  },
  {
    id: 'c82cd5cd-511a-44c6-ae43-5bc49d5ae926',
    nome: 'RECEITA_RENDIMENTO_FINANCEIRO',
    natureza: 'RECEITA',
    descricao: 'Receitas e Rendimentos Financeiros',
  },
  {
    id: '9423b6b3-7587-4706-9bb1-8477598630f5',
    nome: 'RECEITA_NAO_OPERACIONAL',
    natureza: 'RECEITA',
    descricao: 'Outras Receitas Não Operacionais',
  },
  {
    id: '7701525a-f130-4764-bd6c-fe9ebc226cde',
    nome: 'DESPESA_IMPOSTO_VENDA',
    natureza: 'DESPESA',
    descricao: 'Impostos Sobre Vendas',
  },
  {
    id: '23df96bf-49f4-4363-a29e-e5d7ddd2e83d',
    nome: 'DESPESA_COMISSAO_VENDA',
    natureza: 'DESPESA',
    descricao: 'Comissões Sobre Vendas',
  },
  {
    id: 'ab1f7f36-ee25-4c76-bbcd-9e734f5eac6a',
    nome: 'DESPESA_DESCONTO_INCONDICIONAL',
    natureza: 'DESPESA',
    descricao: 'Descontos Incondicionais',
  },
  {
    id: '4a759b1c-da83-4c4c-9d76-4feaaaef9587',
    nome: 'DESPESA_DEVOLUCAO_VENDA',
    natureza: 'DESPESA',
    descricao: 'Devoluções de Vendas',
  },
  {
    id: '5e450fbc-ace6-4b9f-9bfd-5ce75ecbac02',
    nome: 'DESPESA_CUSTO_PRODUTO_VENDIDO',
    natureza: 'DESPESA',
    descricao: 'Custo dos Produtos Vendidos',
  },
  {
    id: 'a8c330cf-e008-4ef8-8423-7890caf87e00',
    nome: 'DESPESA_CUSTO_SERVICO_PRESTADO',
    natureza: 'DESPESA',
    descricao: 'Custo dos Serviços Prestados',
  },
  {
    id: '0e3139a9-5df2-4745-83d2-08a600c3e49e',
    nome: 'DESPESA_COMERCIAL',
    natureza: 'DESPESA',
    descricao: 'Despesas Comerciais',
  },
  {
    id: '4356389d-1ee5-414e-b1a6-8a5e412277ed',
    nome: 'DESPESA_ADMINISTRATIVA',
    natureza: 'DESPESA',
    descricao: 'Despesas Administrativas',
  },
  {
    id: '52e27d94-4ec7-488c-bba6-480e2698796c',
    nome: 'DESPESA_OPERACIONAL',
    natureza: 'DESPESA',
    descricao: 'Despesas Operacionais',
  },
  {
    id: '37e05c8c-749f-4e30-b63c-16bd55aa989f',
    nome: 'DESPESA_FINANCEIRA',
    natureza: 'DESPESA',
    descricao: 'Despesas Financeiras',
  },
  {
    id: '93408d93-3c97-43d8-be23-dcc246db0580',
    nome: 'DESPESA_NAO_OPERACIONAL',
    natureza: 'DESPESA',
    descricao: 'Outras Despesas Não Operacionais',
  },
  {
    id: '0d8133ba-8537-49ee-947c-368d3dd7c84e',
    nome: 'DESPESA_INVESTIMENTO_IMOBILIZADO',
    natureza: 'DESPESA',
    descricao: 'Investimentos em Imobilizado',
  },
  {
    id: '4a108577-1fe4-4b83-9179-2b006772c618',
    nome: 'DESPESA_EMPRESTIMO_DIVIDA',
    natureza: 'DESPESA',
    descricao: 'Empréstimos e Dívidas',
  },
];

const dreMock = {
  get: () => {
    return new Promise((resolve) => {
      resolve(dres);
    });
  },
};

export { dreMock };
